import { useEffect, useState } from "react";
import axios from "axios";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CircularProgress from "@mui/material/CircularProgress";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";
import Cookies from "universal-cookie";
import CrearGestionModal from "./GestionJuridica";
import VerAnexos from "./VerAnexos";
import GestionesJuridica from "./ConsultaGestiones";
import { Button, Select } from "antd";
import ConsultaActual from "./consultaTickets/ConsultaActual";
import ReasignarJuridico from "./Reasignar";
import { Input } from "reactstrap";

function Tables() {
  const cookie = new Cookies();
  const IdUsuario = cookie.get("id");

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [estadoSeleccionado, setEstadoSeleccionado] = useState("");
  const [estados, setEstados] = useState([]);
  const [pagina, setPagina] = useState(1);
  const [totalPaginas, setTotalPaginas] = useState(1);

  const registrosPorPagina = 5;

  const isDataEqual = (oldData, newData) => JSON.stringify(oldData) === JSON.stringify(newData);

  const fetchData = async () => {
    setLoading(true);
    const estado = estadoSeleccionado || "1";

    try {
      const tipoUsuario = cookie.get("tipo_Usuario");
      const url =
        tipoUsuario == 1
          ? `https://contratosback.azurewebsites.net/api/v1/ObtenerJuridicoAsignadas/0/${estado}`
          : `https://contratosback.azurewebsites.net/api/v1/ObtenerJuridicoAsignadas/${IdUsuario}/${estado}`;

      const response = await axios.get(url);
      let data = response.data;

      if (estado === "2" || estado === "4") {
        const dataConFechas = await Promise.all(
          data.map(async (item) => {
            try {
              const gestionesRes = await axios.get(
                `https://contratosback.azurewebsites.net/api/v1/ObtenerGestiones/${item.id}`
              );
              const fechas = gestionesRes.data.map((g) => new Date(g.fechaCreacion));
              const fechaGestion = fechas.length > 0 ? new Date(Math.max(...fechas)) : null;

              return {
                ...item,
                fechaGestion,
                fechaCreacion: new Date(item.fechaCreacion).toLocaleString(),
              };
            } catch {
              return {
                ...item,
                fechaGestion: null,
                fechaCreacion: new Date(item.fechaCreacion).toLocaleString(),
              };
            }
          })
        );

        data = dataConFechas.sort((a, b) => (b.fechaGestion || 0) - (a.fechaGestion || 0));
      } else {
        data = data
          .map((item) => ({
            ...item,
            fechaCreacion: new Date(item.fechaCreacion).toLocaleString(),
          }))
          .sort((a, b) => new Date(b.fechaCreacion) - new Date(a.fechaCreacion));
      }

      if (!isDataEqual(rows, data)) {
        setRows(data);
        setTotalPaginas(Math.ceil(data.length / registrosPorPagina));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchEstados = async () => {
      try {
        const response = await axios.get(
          "https://contratosback.azurewebsites.net/api/v1/ObtenerEstados"
        );
        setEstados(response.data);
      } catch (error) {
        console.error("Error fetching estados:", error);
      }
    };
    fetchEstados();
  }, []);

  useEffect(() => {
    fetchData();
    const interval = setInterval(fetchData, 3000000);
    return () => clearInterval(interval);
  }, [estadoSeleccionado]);

  useEffect(() => {
    const refresh = () => fetchData();
    window.addEventListener("registro-agregado", refresh);
    window.addEventListener("reasignacion-exitosa", refresh);
    return () => {
      window.removeEventListener("registro-agregado", refresh);
      window.removeEventListener("reasignacion-exitosa", refresh);
    };
  }, []);

  const [searchTerm, setSearchTerm] = useState("");

  const filteredRows = rows.filter((row) =>
    Object.values(row).some((value) => value?.toString().toLowerCase().includes(searchTerm))
  );

  const startIndex = (pagina - 1) * registrosPorPagina;
  const rowsPaginados = filteredRows.slice(startIndex, startIndex + registrosPorPagina);

  const columns = [
    { Header: "ID", accessor: "id" },
    {
      Header: "Asignar",
      Cell: ({ row }) =>
        row.original.name === "NUEVO" ? <ReasignarJuridico id={row.original.id} /> : null,
    },
    { Header: "Estado", accessor: "name" },
    { Header: "Tema", accessor: "nombreTema" },
    { Header: "Titulo", accessor: "titulo" },
    { Header: "Fecha Creación", accessor: "fechaCreacion" },
    { Header: "Usuario Creación", accessor: "nombreAsignacion" },
    { Header: "Usuario Asignación", accessor: "nombreCreacion" },
    { Header: "NIT", accessor: "nit" },
    {
      Header: "Añadir Gestión",
      Cell: ({ row }) =>
        row.original.name === "NUEVO" ? <CrearGestionModal id={row.original.id} /> : null,
    },
    {
      Header: "Ver Anexos",
      Cell: ({ row }) => <VerAnexos id={row.original.id} />,
    },
    {
      Header: "Gestiones Jurídicas",
      Cell: ({ row }) => (
        <GestionesJuridica id={row.original.id} descripcion={row.original.descripcion} />
      ),
    },
    {
      Header: "Caso Asociado",
      Cell: ({ row }) => <ConsultaActual id={row.original.id} />,
    },
  ];
  const handleEstadoChange = (value) => {
    setEstadoSeleccionado(value);
    setPagina(1); // vuelve a la primera página al cambiar estado
  };
  useEffect(() => {
    setTotalPaginas(Math.ceil(filteredRows.length / registrosPorPagina));
    setPagina(1); // vuelve a la página 1 al filtrar
  }, [searchTerm, rows]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox mx={2} mt={-3} py={3} px={2} bgColor="info" borderRadius="lg">
                <MDTypography variant="h6" color="white">
                  Solicitudes Jurídicas
                </MDTypography>
              </MDBox>

              <MDBox pt={3}>
                {loading ? (
                  <MDBox display="flex" justifyContent="center" alignItems="center" height="300px">
                    <CircularProgress color="info" />
                  </MDBox>
                ) : (
                  <>
                    <MDBox display="flex" alignItems="center" flexWrap="wrap">
                      <Input
                        placeholder="Buscar por cualquier campo..."
                        onChange={(e) => setSearchTerm(e.target.value.toLowerCase())}
                        style={{ margin: "10px 20px", width: "450px" }}
                      />

                      <Select
                        onChange={handleEstadoChange}
                        value={estadoSeleccionado || ""}
                        style={{ margin: "10px 20px", width: 250 }}
                        placeholder="Buscar por estado"
                        allowClear
                      >
                        <Select.Option value="" disabled>
                          Seleccione un estado
                        </Select.Option>
                        {estados.map((estado) => (
                          <Select.Option key={estado.id} value={estado.id}>
                            {estado.name}
                          </Select.Option>
                        ))}
                      </Select>
                    </MDBox>

                    <DataTable
                      table={{ columns, rows: rowsPaginados }}
                      entriesPerPage={false}
                      showTotalEntries={false}
                      noEndBorder
                    />
                    <MDBox
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                      px={3}
                      py={2}
                    >
                      <MDTypography variant="button" color="text">
                        Página {pagina} de {totalPaginas}
                      </MDTypography>

                      <MDBox display="flex" gap={1}>
                        <Button
                          disabled={pagina === 1}
                          onClick={() => setPagina((prev) => prev - 1)}
                        >
                          Anterior
                        </Button>

                        <Button
                          disabled={pagina === totalPaginas}
                          onClick={() => setPagina((prev) => prev + 1)}
                        >
                          Siguiente
                        </Button>
                      </MDBox>
                    </MDBox>
                  </>
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Tables;
